import { Navigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
import SuburbLandingContent from "../components/SuburbLandingContent";
import SuburbComingSoonContent from "../components/SuburbComingSoonContent";
import {
  getComingSoonSEO,
  getSuburbBySlug,
  getSuburbSEO,
  isSuburbLive,
} from "../data/suburbs";
const SuburbLanding = () => {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, "").replace(/^car-rental-/, "");
  const suburb = getSuburbBySlug(slug);

  if (!suburb) {
    return <Navigate to='/suburbs' replace />;
  }

  const live = isSuburbLive(suburb.slug);
  const seo = live ? getSuburbSEO(suburb) : getComingSoonSEO(suburb);

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        robots={live ? "index, follow" : "noindex, follow"}
      />
      {live ? (
        <>
          <StructuredData type="suburbLocalBusiness" suburb={suburb} />
          <StructuredData
            type="breadcrumb"
            breadcrumbs={[
              { name: "Home", url: "/" },
              { name: "Suburbs", url: "/suburbs" },
              { name: suburb.name, url: `/car-rental-${suburb.slug}` },
            ]}
          />
        </>
      ) : (
        <StructuredData type="organization" />
      )}
      <Navbar />
      {live ? (
        <SuburbLandingContent suburb={suburb} />
      ) : (
        <SuburbComingSoonContent suburb={suburb} />
      )}
      <Footer />
    </>
  );
};

export default SuburbLanding;
